module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-69.352ef46.woff2";